import { jsonCircularHandler } from './jsonHelper';

export const LOCAL_STORAGE_ITEM = {
  USER: 'user',
  USER_ROLES: 'userRoles',
  SESSION_ID: 'sessionId',
  EVENTS_LOG: 'eventsLog',
  LAST_EVENT: 'lastEvent',
  REFRESH_TIME: 'refresh',
  TOKEN: 'token',
  VIDEO_CHAT_V2_MEETING_PRESENCE: 'videoChatV2MeetingPresence',
  VIDEO_CHAT_V2_PENDING_AUTH_ACTIONS: 'videoChatV2PendingAuthActions',
  COGNITO_NEW_PASSWORD_CHALLENGE: 'cognitoNewPasswordChallenge',
  COGNITO_LAST_CONFIRMATION_RESEND: 'cognitoLastConfirmationResend',
  LOCALE: 'locale',
};

export const getFromLocalStorage = (name) => JSON.parse(localStorage.getItem(name));

export const setToLocalStorage = (name, item) => {
  const json = jsonCircularHandler(item);
  localStorage.setItem(name, json);
};

export const removeFromLocalStorage = (name) => {
  localStorage.removeItem(name);
};

export const removeCognitoIdentityServiceProviderItems = (
  clientId = process.env.REACT_APP_COGNITO_APP_CLIENT_ID,
) => {
  try {
    if (!clientId || typeof localStorage === 'undefined') {
      return;
    }
    const prefix = `CognitoIdentityServiceProvider.${clientId}.`;
    Object.keys(localStorage)
      .filter((key) => key.startsWith(prefix))
      // Keep device-tracking keys so "remembered devices" can suppress MFA across logout/login.
      // Cognito stores devices under: <prefix><username>.deviceKey / .randomPasswordKey / .deviceGroupKey
      .filter((key) => !/\.(deviceKey|randomPasswordKey|deviceGroupKey)$/.test(key))
      .forEach((key) => localStorage.removeItem(key));
  } catch (e) {
    // ignore
  }
};
